import {Directive, ElementRef, Input} from '@angular/core';

declare var $: any;

/**
 * truncates the display for table cell answers to prevent the wrapping and shows full answer in a popup.
 * the popup is initialised every time a table cell is de-selected
 */
@Directive({
    selector: '[textTruncate]',
    standalone: false
})
export class TextTruncateDirective {
  @Input() text: string;
  @Input() length?: number; // max characters threshold

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    const defaultmaxLength = 10;

    setTimeout(() => {
      if (this.text && this.text.length > (this.length || defaultmaxLength)) {
        this.el.nativeElement.innerText = `${this.text.substring(0, this.length || defaultmaxLength)}...`;
      } else {
        this.el.nativeElement.innerText = this.text || null;
      }
    });

  }

}
